import teamRequestsModalApproveAllComponent from './teamRequestsModalApproveAll.component';
import teamRequestsModalApproveAllConfirm from './teamRequestsModalApproveAllConfirm/teamRequestsModalApproveAllConfirm';

let teamRequestsModalApproveAllModule = angular.module('vacations-absences.teamRequestsModalApproveAll', [
  teamRequestsModalApproveAllConfirm
])

.component('teamRequestsModalApproveAll', teamRequestsModalApproveAllComponent)

.name;

export default teamRequestsModalApproveAllModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsModalApproveAll/teamRequestsModalApproveAll.js